import { z } from "zod";
/** Dodo checkout (block 31). Monthly $8, annual $72 (A8 C11). */
export const checkoutPlanSchema = z.enum(["monthly", "annual"]);
/** `GET /v1/billing/checkout?plan=` → 200. A Dodo-hosted page the caller navigates to. */
export const checkoutResponseSchema = z.object({ checkoutUrl: z.url() });
/** `GET /v1/billing/portal` → 200 (block 32). `404 no_billing_account` before the first subscription. */
export const portalResponseSchema = z.object({ portalUrl: z.url() });
//# sourceMappingURL=billing.js.map